import { useLocation } from "react-router-dom";
import "../BinTransfer/BinTransferMain.css";
import { ArrowForwardIos } from "@mui/icons-material";
function Breadcrumbs({ type }) {
  const location = useLocation();
  return (
    <div className="mt-1 mb-1 " sx={{ padding: "0px" }}>
      <div>
        <span className="breadcrumb-not-active ">Masters </span>{" "}
        <ArrowForwardIos color="info" style={{ marginRight: "1rem" }} />
        <span className="breadcrumb-not-active ">
          Vendor Discontinue Approve {type}
        </span>
      </div>
    </div>
  );
}
export default Breadcrumbs;
